'use strict';

exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  var actualExtraArgument = extraArgument;
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, actualExtraArgument);
        }

        return next(action);
      };
    };
  };
  // AL 扩展行为，支持更新闭包内的 extraArgument
  middleware.__AL_EX_updateExtraArgument = function (newExtraArgument) {
    actualExtraArgument = newExtraArgument;
  };
  return middleware;
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;